import { render } from "./ReviewSummary.vue?vue&type=template&id=21b21277&scoped=true"
import script from "./ReviewSummary.vue?vue&type=script&lang=js"
export * from "./ReviewSummary.vue?vue&type=script&lang=js"

import "./review-summary.scss?vue&type=style&index=0&id=21b21277&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b21277"]])

export default __exports__